import { Button, IconButton, IconClose24, ModalFullscreen, UIHeading2, UIText1 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './Slide.css';
import { useBooleanState } from '@cian/react-utils';
import { clsx } from 'clsx';
import DOMPurify from 'isomorphic-dompurify';

type SlideProps = {
  title: string;
  description: string | undefined | null;
  imageUrl: string;
  modalTitle: string;
};

export const Slide: React.FC<SlideProps> = ({ title, description, imageUrl, modalTitle }) => {
  const { state, setFalse, setTrue } = useBooleanState();

  // Описание в виде HTML должно поддерживаться для кастомизации с админки, вставлять ссылки и т.д.
  // Но в то же время нужно избегать XSS атак, поэтому используем sanitize
  const sanitizedDescription = React.useMemo(() => description && DOMPurify.sanitize(description), [description]);

  return (
    <>
      <div data-testid="apartment-finishing-slide" className={styles['container']}>
        <img data-testid="image" src={imageUrl} alt={title} className={styles['image']} />
        <div className={styles['content']}>
          <div
            className={clsx(
              styles['content-title'],
              !!sanitizedDescription && styles['content-title--with-description'],
            )}
          >
            <UIHeading2 data-testid="title" color="text-inverted-default">
              {title}
            </UIHeading2>
          </div>
          {!!sanitizedDescription && (
            <div>
              <Button data-testid="more-button" theme="fill_white_primary" onClick={setTrue}>
                Подробнее
              </Button>
            </div>
          )}
        </div>
      </div>

      {!!sanitizedDescription && (
        <ModalFullscreen theme="white" open={state} onClose={setFalse}>
          {state && (
            <div className={styles['modal-container']} data-testid="ApartmentFinishing--modal-container">
              <div className={styles['modal-heading']}>
                <UIText1 data-testid="ApartmentFinishing--modal-heading-text">{modalTitle}</UIText1>

                <IconButton
                  data-testid="ApartmentFinishing--modal-close-button"
                  icon={<IconClose24 />}
                  onClick={setFalse}
                />
              </div>
              <div className={styles['modal-content']}>
                <div className={styles['modal-image-container']}>
                  <img
                    data-testid="ApartmentFinishing--modal-image"
                    src={imageUrl}
                    alt={title}
                    className={styles['modal-image']}
                  />
                </div>
                <div className={styles['modal-info-container']}>
                  <UIHeading2 data-testid="ApartmentFinishing--modal-info-title">{title}</UIHeading2>
                  <div
                    data-testid="ApartmentFinishing--modal-info-description"
                    className={styles['description']}
                    // oxlint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                  />
                </div>
              </div>
            </div>
          )}
        </ModalFullscreen>
      )}
    </>
  );
};
